import { render, staticRenderFns } from "./collection-link.vue?vue&type=template&id=faf756d8&"
import script from "./collection-link.vue?vue&type=script&lang=js&"
export * from "./collection-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports